/* RoRoh: Banner "Gratis dazu: Honigglas (60 g) in jeder Bestellung" im Warenkorb (Drawer + Warenkorbseite).
   Reine Anzeige: liest/aendert keinen Warenkorb und hat nichts mit dem Bestand zu tun. */
(function () {
  'use strict';

  var TEXT_MAIN = '\uD83D\uDC9B Gratis dazu: Honigglas (60 g) in jeder Bestellung';
  var TEXT_SUB = 'solange der Vorrat reicht';
  var pending = false;

  function build() {
    var el = document.createElement('div');
    el.className = 'rr-gift-banner';
    el.setAttribute('role', 'note');
    var a = document.createElement('span');
    a.className = 'rr-gift-banner__main';
    a.textContent = TEXT_MAIN;
    var b = document.createElement('span');
    b.className = 'rr-gift-banner__sub';
    b.textContent = TEXT_SUB;
    el.appendChild(a);
    el.appendChild(b);
    return el;
  }

  function update() {
    pending = false;
    /* Warenkorb-Drawer: nur wenn Produkte drin sind (Footer sichtbar) */
    document.querySelectorAll('.drawer__footer').forEach(function (footer) {
      var drawerOk = !footer.classList.contains('hidden') && footer.closest('cart-drawer');
      var has = footer.parentNode.querySelector(':scope > .rr-gift-banner');
      if (drawerOk && !has) {
        footer.parentNode.insertBefore(build(), footer);
      } else if (!drawerOk && has) {
        has.remove();
      }
    });
    /* Warenkorbseite */
    var side = document.querySelector('main-cart .cart__sidebar');
    if (side && !side.querySelector(':scope > .rr-gift-banner')) {
      side.insertBefore(build(), side.firstChild);
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(update);
  }

  function init() {
    update();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
